import React, {
    useEffect,
    useState,
    useMemo, useCallback,
} from 'react';

import PropTypes from 'prop-types';
import axios from "axios";
import MasterContext from "../MasterContext";
import {gql, useLazyQuery} from "@apollo/client";

const products_dict_name = ["Automotor", "Motovehículo", "Hogar", "Microseguros", "Otros Seguros", "Prevención Salud"]
const products_dict_number = ["0", "1", "2", "3", "4", "5"]

const GET_UNIDADES_DE_NEGOCIO = gql`
    query MyQuery {
      General_Unidades_de_Negocio {
        id
        descripcion
      }
    }
`;

const MasterContextProvider = ({
                                   children,
                               }) => {

    const [isReady, setIsReady] = useState(null)
    const [open, setOpen] = useState(false)
    const [reload, setReload] = useState(false)
    const [affinitiesInfo, setAffinitiesInfo] = useState(null)
    const [advisers, setAdvisers] = useState(null)
    const [modified, setModified] = useState(false);
    const [unidadesNegocioOptions, setUnidadesNegocioOptions] = useState(null);
    const handleModified = useCallback(() => {
        setModified(!modified)
    }, [modified]);

    const togleSideNav = useCallback(() => {
        setOpen(!open)
    }, [open]);

    const togleReload = useCallback(() => {
        setReload(!reload)
    }, [reload]);

    const parseUnidadesNegocio = (data) => {
        let options = data["General_Unidades_de_Negocio"].map(d => ({
            "value": d['id'],
            "label": d['descripcion']
        }));
        setUnidadesNegocioOptions(options);
    };

    const [getUnidadesNegocioData] = useLazyQuery(GET_UNIDADES_DE_NEGOCIO, {
        fetchPolicy: "cache-first",
        onCompleted: parseUnidadesNegocio
    });

    useEffect(() => {
        let shouldUpdate = true;

        const init = async () => {
            let url = process.env.REACT_APP_BACK_SERVER + '/m/consultarAfinidades'
            getUnidadesNegocioData();
            axios.get(url).then((resp) => {
                axios.post(process.env.REACT_APP_BACK_SERVER + '/m/consultarAsesores', {}, {}).then((respAsesores) => {

                    if (shouldUpdate) {
                        setOpen(open)

                        let options = respAsesores['data'].map(d => ({
                            "value": d.idAuth,
                            "label": d.Nombre.toString() + ' ' + d.Apellido.toString() + ' (' + d.DNI + ')',
                        }));
                        setAdvisers(options);

                        resp['data'].map((affinity) => {
                            let activated_products_num = [];
                            let activated_products_names = [];
                            affinity.Productos.map((prod, idx)=>{
                                if(prod === 1){
                                    activated_products_num.push(products_dict_number[idx])
                                    activated_products_names.push(products_dict_name[idx])
                                }
                            });
                            affinity.Productos = activated_products_num
                            affinity.ProductosString = activated_products_names
                        })

                        setAffinitiesInfo(resp['data'])
                        setIsReady(true);
                    }

                })

            })
        }

        init();
        return () => {
            /* This cleanup function is used to prevent updating the state
            when the component is unmounted */
            shouldUpdate = false;
        };

    }, [reload, modified])

    const context = useMemo(() => ({
        togleSideNav,
        open,
        togleReload,
        isReady,
        advisers,
        handleModified,
        unidadesNegocioOptions,
        affinitiesInfo
    }), [
        open,
        togleReload,
        togleSideNav,
        advisers,
        handleModified,
        affinitiesInfo,
        unidadesNegocioOptions,
        isReady
    ]);
    return (
        <MasterContext.Provider value={context}>
            {children}
        </MasterContext.Provider>
    );
}
MasterContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default MasterContextProvider;